import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import { Facebook, Instagram, TikTok, YouTube, Twitter } from "iconoir-react";

export default function Footer() {
  // const fun = () => {
    
  // };
  return (
    <footer>
      <Box
       
        bgcolor="#212529"
        color="white"
        style={{width: "auto", padding: "2rem 0"}}
      >
        <Container maxWidth="lg">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={4}>
              <Box borderBottom={1}>Usuario</Box>
              <Box>
                <Link href="/" color="inherit">
                  Tipo de marcación
                </Link>
              </Box>
              <Box>
                <Link href="/planes" color="inherit">
                  Planes
                </Link>
              </Box>
              <Box>
                <Link
                  onClick={() => {
                    window.scrollTo(0, 1100);
                  }}
                  color="inherit"
                >
                  Provedores de contenido
                </Link>
              </Box>
              <Box>
                <Link href="/" color="inherit"></Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box borderBottom={1}>Contáctenos</Box>
              <Box>
                <Link
                  href="https://www.emcali.com.co/web/telco"
                  target="_blank"
                  color="inherit"
                >
                 Línea de atención: 177
                </Link>
              </Box>
              <Box>
                <Link href="/Login" color="inherit">
                  Ingresar
                </Link>
              </Box>
              <Box>
                <Link href="/Register" color="inherit">
                  Registrarse
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box borderBottom={1}>Normativa</Box>
              <Box>
                <Link
                  href="https://www.emcali.com.co/proteccion-de-datos-personales"
                  target="_blank"
                  color="inherit"
                >
                  Protección Datos Personales
                </Link>
              </Box>
              <Box>
                <Link
                  href="http://speedtest.emcali.net.co"
                  target="_blank"
                  color="inherit"
                >
                  Medidor de Servicio de Datos
                </Link>
              </Box>
              <Box>
                <Link
                  href="https://www.emcali.com.co/proteccion-de-datos-personales"
                  target="_blank"
                  color="inherit"
                >
                  Responsabilidad Social
                </Link>
              </Box>
              <Box>
                <Link
                  href="/Mapano"
                  target="_blank"
                  color="inherit"
                >
                  Mapa de Transporte de Fibra Óptica
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box borderBottom={1}>Síguenos en</Box>
              <Box
              display="flex" 
              justifyContent="center" 
              gap={2} 
              mt={2}
              >
                <Link
                  href="https://www.facebook.com/Emcalioficial01?locale=es_LA"
                  target="_blank"
                  color="inherit"
                >
                  <Facebook style={{ width: "2.5rem", height: "2.5rem" }} />
                </Link>
                <Link
                  href="https://www.instagram.com/emcalioficial/feed/"
                  target="_blank"
                  color="inherit"
                >
                  <Instagram style={{ width: "2.5rem", height: "2.5rem" }} />
                </Link>
                <Link
                  href="https://twitter.com/EMCALIoficial?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                  target="_blank"
                  color="inherit"
                >
                  <Twitter style={{ width: "2.5rem", height: "2.5rem" }} />
                </Link>
                <Link
                  href="https://www.tiktok.com/@emcalioficial"
                  target="_blank"
                  color="inherit"
                >
                  <TikTok style={{ width: "2.5rem", height: "2.5rem" }} />
                </Link>
                <Link
                  href="https://www.youtube.com/emcalioficial"
                  target="_blank"
                  color="inherit"
                >
                  <YouTube style={{ width: "2.5rem", height: "2.5rem" }} />
                </Link>
              </Box>
            </Grid>
          </Grid>
          <Box textAlign="center" pt={{ xs: 5, sm: 10 }} pb={{ xs: 5, sm: 0 }}>
            Emcali &reg; {new Date().getFullYear()}
          </Box>
        </Container>
      </Box>
    </footer>
  );
}
